/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PartnerDetailsDto } from './PartnerDetailsDto';
export type CreateBookingDto = {
    /**
     * Expert UUID
     */
    expert_id: string;
    /**
     * Sub-service UUID
     */
    sub_service_id: string;
    /**
     * Package UUID (for package bookings)
     */
    package_id?: string;
    /**
     * Session type
     */
    session_type: CreateBookingDto.session_type;
    /**
     * Mode
     */
    mode: CreateBookingDto.mode;
    /**
     * Location UUID (for non-online modes)
     */
    location_id?: string;
    /**
     * Selected availability slot IDs
     */
    selected_slot_ids: Array<string>;
    /**
     * Partner details (for duo session type)
     */
    partner_details?: PartnerDetailsDto;
    /**
     * Currency code (optional — backend derives from expert pricing if not provided)
     */
    currency?: string;
    /**
     * Idempotency key to safely retry booking creation without creating duplicates
     */
    idempotency_key: string;
    /**
     * Stripe SDK API version from mobile app
     */
    stripe_api_version: string;
    /**
     * UUID of a saved payment method to charge (skips interactive payment sheet)
     */
    payment_method_id?: string;
    /**
     * Setup future usage
     */
    setup_future_usage: CreateBookingDto.setup_future_usage;
};
export namespace CreateBookingDto {
    /**
     * Session type
     */
    export enum session_type {
        SINGLE = 'single',
        DUO = 'duo',
    }
    /**
     * Mode
     */
    export enum mode {
        ONLINE = 'online',
        CLIENT_LOCATION = 'client_location',
        EXPERT_LOCATION = 'expert_location',
    }
    /**
     * Setup future usage
     */
    export enum setup_future_usage {
        OFF_SESSION = 'off_session',
        ON_SESSION = 'on_session',
    }
}

